export const FETCH_APP_CONFIG = 'FETCH_APP_CONFIG'
export const SET_DATA_LOADER = 'SET_DATA_LOADER'
export const ADD_LOADED_PAGE = 'ADD_LOADED_PAGE'

export const LOG_IN_USER = 'LOG_IN_USER'
export const USER_LOGGING = 'USER_LOGGING'
export const SET_FIRST_SYNC = 'SET_FIRST_SYNC'
export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER'
export const CURRENT_USER_FETCHING = 'CURRENT_USER_FETCHING'
export const USERS_IN_LOADING = 'USERS_IN_LOADING'
export const FILTER_USERS_BY_PATTERN = 'FILTER_USERS_BY_PATTERN'
export const SET_EDITED_USER = 'SET_EDITED_USER'
export const SET_PASSWORD_CONFIGURING_USER = 'SET_PASSWORD_CONFIGURING_USER'

export const FETCH_COUNTRIES = 'FETCH_COUNTRIES'
export const FILTER_COUNTRIES_BY_PATTERN = 'FILTER_COUNTRIES_BY_PATTERN'
export const FIND_COUNTRY = 'FIND_COUNTRY'
export const COUNTRIES_FETCHING = 'COUNTRIES_FETCHING'

export const FETCH_CITIES = 'FETCH_CITIES'
export const FILTER_CITIES_BY_PATTERN = 'FILTER_COUNTRIES_BY_PATTERN'
export const FIND_CITY = 'FIND_CITY'
export const CITIES_FETCHING = 'CITIES_FETCHING'

export const FETCH_PROVINCES = 'FETCH_PROVINCES'
export const FILTER_PROVINCES_BY_PATTERN = 'FILTER_PROVINCES_BY_PATTERN'
export const FIND_PROVINCE = 'FIND_PROVINCE'
export const PROVINCES_FETCHING = 'PROVINCES_FETCHING'

export const FETCH_ZONES = 'FETCH_ZONES'
export const FILTER_ZONES_BY_PATTERN = 'FILTER_ZONES_BY_PATTERN'
export const FIND_ZONE = 'FIND_ZONE'
export const ZONES_FETCHING = 'ZONES_FETCHING'

export const FETCH_COMMUNES = 'FETCH_COMMUNES'
export const FILTER_COMMUNES_BY_PATTERN = 'FILTER_COMMUNES_BY_PATTERN'
export const FIND_COMMUNE = 'FIND_COMMUNE'
export const COMMUNES_FETCHING = 'COMMUNES_FETCHING'

export const FETCH_FAMILIES = 'FETCH_FAMILIES'
export const FILTER_FAMILIES_BY_PATTERN = 'FILTER_FAMILIES_BY_PATTERN'
export const FIND_FAMILY = 'FIND_FAMILY'
export const FAMILIES_FETCHING = 'FAMILIES_FETCHING'
export const ADD_FAMILY = 'ADD_FAMILY'
export const DELETE_FAMILY = 'DELETE_FAMILY'

export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FILTER_PRODUCTS_BY_PATTERN = 'FILTER_PRODUCTS_BY_PATTERN'
export const FIND_PRODUCT = 'FIND_PRODUCT'
export const PRODUCTS_FETCHING = 'PRODUCTS_FETCHING'
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const DELETE_PRODUCT = 'DELETE_PRODUCT'

export const INIT_CART = 'INIT_CART'
export const REFRESH_LINES = 'REFRESH_LINES'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const SET_CART_CUSTOMER = 'SET_CART_CUSTOMER'
export const SET_CART_DATE = 'SET_CART_DATE'
export const SET_CART_MEMBER_TYPE = 'SET_CART_MEMBER_TYPE'
export const SET_CART_REDUCTION = 'SET_CART_REDUCTION'

export const FETCH_MEMBERS = 'FETCH_MEMBERS'
export const FILTER_MEMBERS_BY_PATTERN = 'FILTER_MEMBERS_BY_PATTERN'
export const FIND_MEMBER = 'FIND_MEMBER'
export const MEMBERS_FETCHING = 'MEMBERS_FETCHING'
export const ADD_MEMBER = 'ADD_MEMBER'
export const DELETE_MEMBER = 'DELETE_MEMBER'
export const COUNT_MEMBER = 'COUNT_MEMBER'
export const FETCH_AUTO_ENROLLED = 'FETCH_AUTO_ENROLLED'

export const SIDEBAR_SET = 'set'
export const DASHBOARD_SET_ORGANE = 'DASHBOARD_SET_ORGANE'
export const DASHBOARD_START_LOADING_DATA = 'DASHBOARD_START_LOADING_DATA'
export const DASHBOARD_END_LOADING_DATA = 'DASHBOARD_END_LOADING_DATA'
export const DASHBOARD_FETCH_GROUP_COUNT_DATA = 'DASHBOARD_FETCH_GROUP_COUNT_DATA'
export const DASHBOARD_FETCH_ORGANE_COUNT_DATA = 'DASHBOARD_FETCH_ORGANE_COUNT_DATA'
export const DASHBOARD_FETCH_ORGANE_DATA = 'DASHBOARD_FETCH_ORGANE_DATA'
export const DASHBOARD_FETCH_LATEST_SUBSCRIBERS_DATA = 'DASHBOARD_FETCH_LATEST_SUBSCRIBERS_DATA'
export const DASHBOARD_FETCH_COUNT_ALL_LAST_BY_ORGANE_DATA =
  'DASHBOARD_FETCH_COUNT_ALL_LAST_BY_ORGANE_DATA'
export const DASHBOARD_FETCH_DATA = 'DASHBOARD_FETCH_DATA'

export const FETCH_ORGANES = 'FETCH_ORGANES'
export const ORGANES_FETCHING = 'ORGANES_FETCHING'
export const FIND_ORGANE = 'FIND_ORGANE'

export const FETCH_PAGES_STATE_PARAMS = 'FETCH_PAGES_STATE_PARAMS'
export const SET_PAGE_STATE_PARAMS = 'SET_PAGE_STATE_PARAMS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const RESET_PAGES_STATE_PARAMS = 'RESET_PAGES_STATE_PARAMS'

export const SET_EDITED_CARD = 'SET_EDITED_CARD'
